import { ProductEditScreen } from "./product-edit.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";

export const ProductEditRoutes: RouteDefinition[] = [
	{
		path: Paths.products.withIdPlaceholder().edit.path,
		element: <ProductEditScreen />,
		requiredPermissions: [
			"UserInAccountPermission_ProductAdmin_Read",
			"UserInAccountPermission_ProductAdmin_Modify",
		],
	},
];
